import { CurrencyCode } from '@noths/polaris-dev-ts-types';

export const addItemToBasketMutation = (currency: CurrencyCode) => `
mutation addItem($code: String!, $quantity: Int!, $options: [ProductOptionInput]) {
  addItem(code: $code, quantity: $quantity, options: $options) {
    basket(currency:${currency}) {
      itemsCount,
      itemsTotal { currency, cents }, 
    }
    errors { code, path, message }
    trackingData: basket(currency: GBP) {
      analyticsId, discountedItemsTotal { currency, cents },
      items { quantity, purchasePrice { currency, cents }, product { code, prices { listPrice { currency, cents } } } }
    } 
  }
}
`;

export const updateItemMutation = (currency: CurrencyCode) =>
  `mutation updateItem($id: ID!, $options: [ProductOptionInput], $quantity: Int!) {
    updateItem(id: $id, options: $options, quantity: $quantity) {
      basket(currency: ${currency}) {
        itemsCount,
        itemsTotal { currency, cents }, 
        items {
          id
          quantity
        }
      }
      errors {
        code
        path
        message
      }
    }
  }`;

export const getProductCustomisationOptionsQuery = () => `
query getProductCustomisationOptionsQuery {
  basket {
    itemsCount,
    itemsTotal { currency, cents }, 
    items {
      id
      quantity
      options {
        optionId
        name
        type
        valueLabel
        value
        valueId
        prices {
          listPrice {
            currency
            cents
          }
          purchasePrice {
            currency
            cents
          }
          discountValue {
            currency
            cents
          }
          discountType
          discountPercent
        }
      }
    }
  }
}  
`;
